/** @format */
import { CustomerRoles } from "../../utils/enums";

export { CustomerRoles };
export const isAdmin = roles => roles.indexOf(CustomerRoles.ADMIN) !== -1;
